import { computed, ref } from 'vue'

const _isRTLEnabled = ref(false)

export const isRTL = computed(() => _isRTLEnabled.value)

export function enableRTL () {
    _isRTLEnabled.value = true
    document.body.classList.add('rtl')
    document.documentElement.dir = 'rtl'
}

export function disableRTL () {
    _isRTLEnabled.value = false
    document.body.classList.remove('rtl')
    document.documentElement.dir = 'ltr'
}

